import http from "./httpService";

const baseUrl = `/auth`;

export const authenticateUser = async (email, password) => {
  try {
    const {
      status,
      data: { user, token },
    } = await http.post(`${baseUrl}/login`, {
      email,
      password,
    });

    return { user, token, status };
  } catch (err) {
    return { status: err.response.status };
  }
};

// Request a password-reset link (delivered to the admin over Slack).
// Always resolves to a generic message — the server never reveals whether the
// email is an admin.
export const forgotPassword = async (email) => {
  try {
    const { status, data } = await http.post(`${baseUrl}/forgot-password`, { email });
    return { status, message: data.message };
  } catch (err) {
    return { status: err?.response?.status || 500, message: err?.response?.data?.message };
  }
};

// Validate an admin invite token before showing the set-password form.
export const validateInvite = async (token) => {
  try {
    const { status, data } = await http.get(`${baseUrl}/invite/${token}`);
    return { status, invite: data.invite };
  } catch (err) {
    return { status: err?.response?.status || 400, message: err?.response?.data?.message };
  }
};

// Consume an invite token and set the account password.
export const setPassword = async (token, password) => {
  try {
    const { status, data } = await http.post(`${baseUrl}/set-password`, { token, password });
    return { status, message: data.message };
  } catch (err) {
    return { status: err?.response?.status || 400, message: err?.response?.data?.message };
  }
};
